export var NotificationType;
(function (NotificationType) {
    NotificationType["MOMENT_LAUNCHED"] = "MOMENT_LAUNCHED";
    NotificationType["SUBMISSION_RECEIVED"] = "SUBMISSION_RECEIVED";
    NotificationType["SUBMISSION_APPROVED"] = "SUBMISSION_APPROVED";
    NotificationType["REWARD_CLAIMED"] = "REWARD_CLAIMED";
    NotificationType["REWARD_FULFILLED"] = "REWARD_FULFILLED";
    NotificationType["SUBMISSION_REJECTED"] = "SUBMISSION_REJECTED";
    NotificationType["CLAIM_CANCELLED"] = "CLAIM_CANCELLED";
    // Proactive admin nudges (daily engagement job, 48h throttle per admin)
    NotificationType["NUDGE_NO_MOMENT"] = "NUDGE_NO_MOMENT";
    NotificationType["NUDGE_NO_SUBMISSION"] = "NUDGE_NO_SUBMISSION";
    // Monday 11:00 ET, opens the Game Plan card on the admin dashboard
    NotificationType["WEEKLY_GAME_PLAN"] = "WEEKLY_GAME_PLAN";
    // An admin sent an employee kudos (a note, optionally with bonus points)
    NotificationType["KUDOS_RECEIVED"] = "KUDOS_RECEIVED";
})(NotificationType || (NotificationType = {}));
